module.exports = __webpack_public_path__ + "img/p1.62299f21.png";